module.exports = __webpack_public_path__ + "static/media/Sopilka1.61095b3f.mp3";